import angular from 'angular';
import uiRouter from 'angular-ui-router';
import addedItemComponent from './addedItem.component';

let addedItemModule = angular.module('addedItem', [
  uiRouter
])

.component('addedItem', addedItemComponent)

.name;

export default addedItemModule;
